import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-page-link.svg";
import * as styles from "./Icon.module.scss";

type PageLinkProps = React.SVGProps<SVGSVGElement>;

export const PageLink = ({ className, ...props }: PageLinkProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
